import React from 'react';
import TrackingContainer from '../../container/admin/tracking';

const Tracking = () => {
    return <TrackingContainer />;
};

export default Tracking; 